// parameter-value.service.js

import axiosInstance from "../axiosInstance";

export const parameterValueService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/forecast-parameter-value", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (parameter, query, client_id) => {
    try {
      let api = `/forecast-parameter-value?&$populate[0][path]=client_id&$populate[0][select]=business_name`;

      if (parameter) {
        query += `&type=${parameter}`;
      }
      if (client_id && query.indexOf("client_id=") === -1) {
        query += `&client_id=${client_id}`;
      }
      if (query) {
        api += `&${query}`;
      }
      let response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.put(
        `/forecast-parameter-value/${id}`,
        obj
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(
        `/forecast-parameter-value/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getAggregated: async (type, period = "monthly", dateFrom, dateTo) => {
    try {
      let queryParams = `period=${period}`;
      if (dateFrom) queryParams += `&date_from=${dateFrom}`;
      if (dateTo) queryParams += `&date_to=${dateTo}`;

      let response = await axiosInstance.get(
        `/forecast-parameter-value/aggregated/${type}?${queryParams}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
